/* import __COLOCATED_TEMPLATE__ from './lsg-button.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { BUTTON_CLASS, BUTTON_TYPES__BUTTON_CLASS_MAP, BUTTON_TYPES } from 'sh-www/constants/lsg';

import clsx from 'clsx';

class LsgButtonComponent extends Component {
  get linkTo() {
    return Boolean(this.args.route);
  }

  get button() {
    const { href } = this.args;
    return !href || href === '#';
  }

  get models() {
    const modelOrModels = this.args.model ?? this.args.models;

    if (!modelOrModels) {
      return [];
    }

    return Array.isArray(modelOrModels)
      ? modelOrModels
      : [modelOrModels];
  }

  get query() {
    return this.args.query ?? { };
  }

  get classNames() {
    const buttonTypeClass = BUTTON_TYPES__BUTTON_CLASS_MAP[this.args.buttonType || BUTTON_TYPES.PRIMARY_SMALL];

    if (!buttonTypeClass) {
      throw new Error('LSG-Button: "buttonType" invalid.');
    }

    return clsx(
      this.args.class,
      BUTTON_CLASS,
      buttonTypeClass,
      this.args.disabled && BUTTON_TYPES__BUTTON_CLASS_MAP[BUTTON_TYPES.DISABLED],
    );
  }

  @action
  onClick(e) {
    if (this.args.disabled) {
      e.preventDefault();
    } else {
      this.args.action?.(...arguments);
    }
  }
}

export default LsgButtonComponent;
